import axios from 'axios';
import { Poster, Figure, InvestorPitch } from '../types';

const API_URL = import.meta.env.VITE_API_URL || '/api';

const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const api = {
  uploadPoster: async (file: File): Promise<Poster> => {
    const formData = new FormData();
    formData.append('poster', file);
    const { data } = await apiClient.post('/posters/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data;
  },

  getPoster: async (id: string): Promise<Poster> => {
    const { data } = await apiClient.get(`/posters/${id}`);
    return data;
  },

  updatePoster: async (id: string, updates: Partial<Poster>): Promise<Poster> => {
    const { data } = await apiClient.put(`/posters/${id}`, updates);
    return data;
  },

  getFigures: async (posterId: string): Promise<Figure[]> => {
    const { data } = await apiClient.get(`/figures/${posterId}`);
    return data;
  },

  createFigure: async (posterId: string, figure: Partial<Figure>): Promise<Figure> => {
    const { data } = await apiClient.post(`/figures/${posterId}`, figure);
    return data;
  },

  updateFigure: async (
    posterId: string,
    figureId: string,
    updates: Partial<Figure>
  ): Promise<Figure> => {
    const { data } = await apiClient.put(`/figures/${posterId}/${figureId}`, updates);
    return data;
  },

  deleteFigure: async (posterId: string, figureId: string): Promise<void> => {
    await apiClient.delete(`/figures/${posterId}/${figureId}`);
  },

  generatePitch: async (posterId: string): Promise<InvestorPitch> => {
    const { data } = await apiClient.post(`/posters/${posterId}/pitch`);
    return data;
  },

  askAI: async (posterId: string, question: string): Promise<string> => {
    const { data } = await apiClient.post(`/posters/${posterId}/ask`, { question });
    return data.answer;
  },

  explainSection: async (posterId: string, section: string): Promise<string> => {
    const { data } = await apiClient.post(`/posters/${posterId}/explain`, { section });
    return data.explanation;
  },

  getDemoPoster: async (): Promise<Poster> => {
    const { data } = await apiClient.get('/posters/demo');
    return data;
  },
};

